import styled from "styled-components";
import { MachineCard } from "../Investment/Investment.styled";

export const StakeContainer = styled.div`
  margin: 15px;
`;

export const StakeCard = styled.div`
  display: flex;
  justify-content: space-between;
  border: 1px solid #7b36ee;
  border-radius: 10px;
  padding: 10px 30px;
  margin-block: 10px;
  background-color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
`;

export const StakeWrapper = styled.div`
  display: flex;
  width: 60%;
  display: flex;
  align-items: center;
  height: 40px;
  /* border: none; */
  /* background-color: ${({ theme }) => theme.colors.primary};
    padding-inline: 10px; */
`;
export const StakeInput = styled.input`
  width: 100%;
  height: 40px;
  border: 1px solid #7b36ee;
  border-radius: 0;
  background-color: ${({ theme }) => theme.colors.primary};
  padding-inline: 10px;

  /* Chrome, Safari, Edge, Opera */
  &&::-webkit-outer-spin-button,
  &&::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &&[type="number"] {
    appearance: textfield;
    -moz-appearance: textfield;
  }
`;

export const StakeButton = styled.button`
  width: 30%;
  height: 50px;
`;

export const StakeBalanceCard = styled(MachineCard)`
  border: transparent;
  border-radius: 0px;
  padding-inline: 20px;
  margin-block: 50px 30px;
`;
